import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { environment } from 'src/environments/environment';
import { PlacesResult } from '../models/googleApis';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class RegionService {

  constructor(private dataService: DataService,
    private http: HttpClient) {
  };

  private autoCompleteCache = new Map<string, PlacesResult[]>()


  getData(url: any) {
    return this.dataService.getRecord(url).map(response => {
      this.dataService.clearRouteCache(url);
      return response;
    });
  }


  register(userform_data: any) {
    return this.dataService.post('/api/register', userform_data).map(user => {
      return user;
    });
  }

  callPostAction(data: any) {
    return this.dataService.post('/api/saveapplication/', data).map(user => {
      return user;
    });
  }

  updatePostAction(data: any) {
    return this.dataService.post('/api/updateapplication', data).map(user => {
      return user;
    });
  }

  updatePermitVehicle(data: any) {
    return this.dataService.post('/api/update/permit', data).map(user => {
      return user;
    });
  }

  delPermitMeasurements(data: any) {
    return this.dataService.post('/api/delPermitMeasurements', data).map(user => {
      return user;
    });
  }

  updatePermitMeasurements(data) {
    return this.dataService.post('/api/updatePermitMeasurements', data).map(user => {
      return user;
    });
  }

  post(url: any, data: any) {
    return this.dataService.post(url, data).map(user => {
      return user;
    });
  }

  payfees(data: any) {
    return this.dataService.post('/api/payfor', data).map(user => {
      return user;
    });
  }

  payformfees(data: any) {
    return this.dataService.post('/api/payfees', data).map(user => {
      return user;
    });
  }

  saveApplicationDetails(data: any, user_id: any) {
    return this.dataService.post('/api/saveapplicant', data).map(response => {
      return response;
    });
  }

  postAction(data: any) {
    return this.dataService.post('/api/saveaction', data).map(response => {
      return response;
    });
  }
  postChallanAction(data: any) {
    return this.dataService.post('/echallan/payment_saveaction', data).map(response => {
      return response;
    });
  }

  getapplicationlist(status_id: any) {

    //return this.dataService.getData('/api/listapplications', true);
    return this.dataService.post('/api/listapplications', status_id).map(response => {
      return response;
    });
  }

  getdashboardData(data: any) {
    return this.dataService.post('/api/getHomeData', data).map(response => {
      return response;
    });
  }

  getRulesDashboardData(data: any) {
    return this.dataService.post('/api/getRulesDashboardData', data).map(response => {
      return response;
    });
  }

  updateRulesDashboardData(data: any) {
    return this.dataService.post('/api/getRulesDashboardUpdate', data).map(response => {
      return response;
    });
  }

  getFinancialYears() {
    return this.dataService.getRecord('/api/getFinancialYears').map(response => {
      return response;
    })
  }

  getEpermitHomeData(data: any) {
    return this.dataService.post('/api/getEpermitHomeData', data).map(response => {
      return response;
    });
  }

  getEpermitDashboardData(data: any) {
    return this.dataService.post('/api/getEpermitDashboardData', data).map(response => {
      return response;
    });
  }

  updateEpermitDashboardData(data: any) {
    return this.dataService.post('/api/getEpermitDashboardUpdate', data).map(response => {
      return response;
    });
  }

  getPermitList(status_id) {

    return this.dataService.post('/api/list/permit', status_id).map(response => {
      return response;
    });

  }
  setGPSAlertStatus(data: any) {
    return this.dataService.post('/api/setGPSAlertStatus', data).map(response => {
      return response;
    });
  }

  getTrackingDetails() {
    return this.dataService.getRecord('/api/trackingDetails').map(result => {
      return result;
    });
  }

  getTrackingApplicantDetails() {
    return this.dataService.getRecord('/api/trackingApplicantDetails').map(result => {
      return result;
    });
  }

  getExistingMines() {
    return this.dataService.getRecord('/api/oldApplicationCount').map(result => {
      return result;
    });
  }

  applicantsCount() {
    return this.dataService.getRecord('/api/applicantsCount').map(result => {
      return result;
    });
  }

  getDispatchList(data: any) {
    return this.dataService.post('/api/list/dispatch', data).map(result => {
      return result;
    });
  }

  getCreateDispatchList() {
    return this.dataService.getRecord('/api/list/dispatchslips').map(result => {
      return result;
    });
  }


  listTaminDivisions() {
    return this.dataService.getRecord('/api/listTaminDivisions').map(result => {
      return result;
    });
  }

  setSubuserStatus(id, userId, status) {
    let payload = {
      "id": id,
      "user_id": userId,
      "status": status
    }
    return this.dataService.post('/api/setSubuserStatus', payload).map(response => {
      return response;
    });
  }


  setSubuserPassword(id, userId) {
    let payload = {
      "id": id,
      "user_id": userId,
    }
    return this.dataService.post('/api/setSubuserPassword', payload).map(response => {
      return response;
    });
  }

  getApplicantSubusers() {
    return this.dataService.getRecord('/api/getApplicantSubusers').map(result => {
      return result;
    });
  }


  getVehicleInOutList() {
    return this.dataService.getRecord('/api/getVehicleInOutList').map(result => {
      return result;
    });
  }

  getYardList() {
    return this.dataService.getRecord('/api/getYardList').map(result => {
      return result;
    });
  }

  getApplicantStorages() {
    return this.dataService.getRecord('/api/getApplicantStorages').map(result => {
      return result;
    });
  }

  DeviceList() {
    return this.dataService.getRecord('/api/list_device').map(result => {
      return result;
    });
  }
  deleteStockYard(data) {
    let payload = {
      "id": data
    }
    return this.dataService.post('/api/deleteStockYard', payload).map(response => {
      return response;
    });
  }

  deleteVehicle(data) {
    let payload = {
      "id": data
    }
    return this.dataService.post('/api/delete_vehicle', payload).map(response => {
      return response;
    });
  }

  deleteDevice(data) {
    let payload = {
      "id": data
    }
    return this.dataService.post('/api/delete_device', payload).map(response => {
      return response;
    });
  }

  listTransitForm() {
    return this.dataService.getRecord('/api/listTransitForm').map(result => {
      return result;
    });
  }

  mineWeighbridgeList() {
    return this.dataService.getRecord('/api/mineWeighbridgeList').map(result => {
      return result;
    });
  }

  getallMineWeighbridgeList() {
    return this.dataService.getRecord('/api/allMineWeighbridgeList').map(result => {
      return result;
    });
  }
  
  getRoleUsers(data: any) {
    return this.dataService.post('/api/getRoleUsers', data).map(result => {
      return result;
    });
  }

  getAllUser() {
    return this.dataService.getRecord('/api/getAllUsers').map(response => {
      return response;
    });
  }



  getTotalSlipUsed(minecode, mineral) {
    let data = {
      "minecode": minecode,
      "minerals": mineral
    }
    return this.dataService.post('/api/view/permit', data).map(response => {
      return response;
    });
  }

  getStartDate(data) {

    return this.dataService.post('/api/getStartDate', data).map(response => {
      return response;
    });
  }

  getApplicationCount(data) {

    return this.dataService.post('/api/summary', data).map(response => {
      return response;
    });
  }

  userapplications(url: any, data: any) {
    return this.dataService.getData(url, data).map(user => {
      return user;
    });
  }



  userpendingapplications(url: any) {
    return this.dataService.getRecord(url).map(user => {
      return user;
    });
  }

  getApplication(id) {
    // return this.dataService.getRecord('/api/processapplicant/' + user_id).map(user => {
    //   return user;
    // });
    return this.dataService.getRecord('/api/viewapplication/' + id).map(user => {
      return user;
    });
  }

  getServices(variable) {
    let url = '/api/getgrid/' + variable;
    return this.dataService.getRecord(url).map(response => {
      this.dataService.clearRouteCache(url);
      return response;
    });
  }

  getWorkflowSteps(variable) {
    let url = '/api/workflowsteps/' + variable;
    return this.dataService.getRecord(url).map(response => {
      this.dataService.clearRouteCache(url);
      return response;
    });
  }

  getAppList(url: any) {
    return this.dataService.getRecord(url).map(user => {
      return user;
    });
  }

  getMajorMinerals() {
    return this.dataService.getRecord('/api/major_minerals').map(res => {
      return res;
    });
  }
  getdistrictwiseApplicant(data) {
    return this.dataService.post('/api/applicant/list', data).map(response => {
      return response;
    });
  }
  getRulewiseMineralPeriod(payload: any) {
    return this.dataService.post('/api/getMineralDetails', payload).map(response => {
      return response;
    });
  }

  getChecksum(data) {
    return this.dataService.post('/api/getchecksum', data).map(response => {
      return response;
    });
  }

  getstatuslist() {
    return this.dataService.getData('/api/appstatus/list', true);
  }

  getDistrictTypeList() {
    return this.dataService.getData('/api/getTndistricts', true);
  }

  getMembersReportInputs() {
    let data = {};
    return this.dataService.post('/api/getMembersReportInputs', data).map(response => {
      return response;
    });
  }

  getStorageReportInputs() {
    let data = {};
    return this.dataService.post('/api/getStorageReportInputs', data).map(response => {
      return response;
    });
  }

  getApplReportInputs() {
    let data = {};
    return this.dataService.post('/api/getApplReportInputs', data).map(response => {
      return response;
    });
  }

  getExistingApplReportInputs() {
    let data = {};
    return this.dataService.post('/api/getExistMinesReportInputs', data).map(response => {
      return response;
    });
  }

  getMineralReportInputs() {
    let data = {};
    return this.dataService.post('/api/getMineralReportInputs', data).map(response => {
      return response;
    });
  }


  getEpemitReportInputs() {
    let data = {};
    return this.dataService.post('/api/getEpemitReportInputs', data).map(response => {
      return response;
    });
  }

  getEpermitTransReportInputs() {
    let data = {};
    return this.dataService.post('/api/getEpermitTransReportInputs', data).map(response => {
      return response;
    })
  }

  getMembersReportList(data: any) {
    return this.dataService.post('/api/getMembersReportList', data).map(response => {
      return response;
    });
  }

  getStorageReportList(data: any) {
    return this.dataService.post('/api/getStorageReportResults', data).map(response => {
      return response;
    });
  }

  updateApplicantEmail(data: any) {
    return this.dataService.post('/api/updateApplicantEmail', data).map(response => {
      return response;
    });
  }

  getEpemitReportList(data: any) {
    return this.dataService.post('/api/getEpemitReportList', data).map(response => {
      return response;
    });
  }

  getApplReportResults(data: any) {
    return this.dataService.post('/api/getApplReportResults', data).map(response => {
      return response;
    });
  }

  getExistingApplReportResults(data: any) {
    return this.dataService.post('/api/getExistMinesReportResults', data).map(response => {
      return response;
    });
  }
  getDispatchReportList(data: any) {
    return this.dataService.post('/api/getDispatchReportList', data).map(response => {
      return response;
    });
  }
  getDispatchWeightReport(data: any) {
    return this.dataService.post('/api/getDispatchWeightReport', data).map(response => {
      return response;
    });
  }
  getRevenueReportInputs() {
    let data = {};
    return this.dataService.post('/api/getRevenueReportInputs', data).map(response => {
      return response;
    });
  }

  getMineralReportResult(data: any) {
    return this.dataService.post('/api/getMineralReportResult', data).map(response => {
      return response;
    });
  }
  getTransitPassReportList(data: any) {
    return this.dataService.post('/api/getTransitPassReportList', data).map(response => {
      return response;
    });
  }

  getApproveQtyReport(data: any) {
    return this.dataService.post('/api/approveQtyReport', data).map(response => {
      return response;
    });
  }

  getAvailableQtyReport(data: any) {
    return this.dataService.post('/api/getAvailableQtyReport', data).map(response => {
      return response;
    });
  }

  getCOMReportResults(data: any) {
    return this.dataService.post('/api/getCOMReportResults', data).map(response => {
      return response;
    });
  }


  getCOMOtherReportResults(data: any) {
    return this.dataService.post('/api/getCOMOtherReportResults', data).map(response => {
      return response;
    });
  }


  getComPayments(data: any) {
    return this.dataService.post('/api/getCOMPayments', false).map(response => {
      return response;
    });
  }

  getRevenueReportResults(data: any) {
    return this.dataService.post('/api/getRevenueReportResults', data).map(response => {
      return response;
    });
  }
  getEperRevenueReportList(data: any) {
    return this.dataService.post('/api/getEperRevenueReportList', data).map(response => {
      return response;
    });
  }
  permitRevenueExport(data: any) {
    return this.dataService.postGetCSV('/api/permitRevenueExport', data).map(response => {
      return response;
    });
  }
  getEperTransReportList(data: any) {
    return this.dataService.post('/api/getEpermitTransReportList', data).map(response => {
      return response;
    })
  }
  getRuleList() {
    return this.dataService.getData('/api/workflowsall', true);
  }


  getActionForm(application_id: any) {
    return this.dataService.getData('/api/getform/' + application_id, true);
  }

  getnewapplicationlist(user_id: any) {
    return this.dataService.getData('/api/userworkflows', true);
  }

  getnewapplicant(user_id: any) {
    return this.dataService.getData('/api/getapplicant', true);
  }

  getApplicantList(data: any) {
    return this.dataService.getData('/api/vieweTransferList', true);
  }

  getSecurityPaperList(data: any) {
    return this.dataService.post('/api/getSecurityPapersList', data).map(response => {
      return response;
    });
  }

  getSecurityPapersListStats(data: any) {
    return this.dataService.post('/api/getSecurityPapersListStats', data).map(response => {
      return response;
    });
  }

  getSPDispatchExport(data: any) {
    return this.dataService.post('/api/getSPDispatchExport', data).map(response => {
      return response;
    });
  }

  getSPOfficersList(data: any) {
    return this.dataService.post('/api/getSPOfficersList', data).map(response => {
      return response;
    });
  }

  getSecurityBatchList(data: any) {
    return this.dataService.post('/api/getSecurityBatchList', data).map(response => {
      return response;
    });
  }

  getSecurityPaperBatchReport(data: any) {
    return this.dataService.post('/api/getSecurityPaperBatchReport', data).map(response => {
      return response;
    })
  }

  getSecurityPaperReport(data: any) {
    return this.dataService.post('/api/getSecurityPaperReport', data).map(response => {
      return response;
    })
  }

  saveBatchCountReport(data: any) {
    return this.dataService.post('/api/saveBatchCountReport', data).map(response => {
      return response;
    })
  }

  viewSecurityPaperData(payload: any) {
    return this.dataService.post('/api/viewSecurityPapers', payload).map(response => {
      return response;
    });
  }

  getPaperEnd(data: any) {
    return this.dataService.post('/api/getPaperEnd', data).map(response => {
      return response;
    })
  }

  getSecuritypaperTypes() {
    return this.dataService.getData('/api/getSecurityPaperTypes', true);
  }

  getSPaperTypes() {
    return this.dataService.getData('/api/getSPaperTypes', true);
  }

  getSecurityPaperPrefix(data: any) {
    return this.dataService.post('/api/getSecurityPaperPrefix', data).map(response => {
      return response;
    })
  }

  checkSerialExist(data: any) {
    return this.dataService.post('/api/checkSerialExist', data).map(response => {
      return response;
    })
  }

  checkPaperExist(data: any) {
    return this.dataService.post('/api/checkPaperExist', data).map(response => {
      return response;
    })
  }

  checkDistrictPaperGiven(data: any) {
    return this.dataService.post('/api/checkDistrictPaperGiven', data).map(response => {
      return response;
    })
  }

  saveBatchCount(data) {
    return this.dataService.post('/api/saveBatchCount', data).map(response => {
      return response;
    });
  }

  saveSecurityBatch(data) {
    return this.dataService.post('/api/saveSecurityBatch', data).map(response => {
      return response;
    });
  }

  getNewSerial(data) {
    return this.dataService.post('/api/getNewSerial', data).map(response => {
      return response;
    });
  }

  getSPStatus(data: any) {
    return this.dataService.post('/api/getSPStatus', data).map(response => {
      return response;
    })
  }

  viewSecurityBatch(data: any) {
    return this.dataService.post('/api/viewSecurityBatch', data).map(response => {
      return response;
    })
  }

  checkBatchAssigned(data: any) {
    return this.dataService.post('/api/checkBatchAssigned', data).map(response => {
      return response;
    })
  }

  delPaperBatch(data: any) {
    return this.dataService.post('/api/delPaperBatch', data).map(response => {
      return response;
    })
  }

  checkSPExist(data: any) {
    return this.dataService.post('/api/checkSPExist', data).map(response => {
      return response;
    })
  }

  checkSPBExist(data: any) {
    return this.dataService.post('/api/checkSPBExist', data).map(response => {
      return response;
    })
  }

  setPaperasDamage(data: any) {
    return this.dataService.post('/api/setPaperasDamage', data).map(response => {
      return response;
    })
  }

  setUserPaperasDamage(data: any) {
    return this.dataService.post('/api/setUserPaperasDamage', data).map(response => {
      return response;
    })
  }

  getSPDamageList(data: any) {
    return this.dataService.post('/api/getSPDamageList', data).map(response => {
      return response;
    })
  }

  getSPDRequestMines(data: any) {
    return this.dataService.post('/api/getSPDRequestMines', data).map(response => {
      return response;
    })
  }

  getSPDRequestMineDets(data: any) {
    return this.dataService.post('/api/getSPDRequestMineDets', data).map(response => {
      return response;
    })
  }

  getSPDRequestOfficers(data: any) {
    return this.dataService.post('/api/getSPDRequestOfficers', data).map(response => {
      return response;
    })
  }

  getSPDRequestADDets(data: any) {
    return this.dataService.post('/api/getSPDRequestADDets', data).map(response => {
      return response;
    })
  }

  saveSPDRequestReplace(data: any) {
    return this.dataService.post('/api/saveSPDRequestReplace', data).map(response => {
      return response;
    })
  }

  getSPDRequestMineList(data: any) {
    return this.dataService.post('/api/getSPDRequestMineList', data).map(response => {
      return response;
    })
  }

  showSPDRequestMineDets(data: any) {
    return this.dataService.post('/api/showSPDRequestMineDets', data).map(response => {
      return response;
    })
  }

  getSPDRequestList(data: any) {
    return this.dataService.post('/api/getSPDRequestList', data).map(response => {
      return response;
    })
  }

  getSPDRequestDets(data: any) {
    return this.dataService.post('/api/getSPDRequestDets', data).map(response => {
      return response;
    })
  }

  getSPDRequestAccept(data: any) {
    return this.dataService.post('/api/getSPDRequestAccept', data).map(response => {
      return response;
    })
  }

  getSPDamageDets(data: any) {
    return this.dataService.post('/api/getSPDamageDets', data).map(response => {
      return response;
    })
  }

  setSPDamageReceived(data: any) {
    return this.dataService.post('/api/setSPDamageReceived', data).map(response => {
      return response;
    })
  }

  getSPReceiveDets(data: any) {
    return this.dataService.post('/api/getSPReceiveDets', data).map(response => {
      return response;
    })
  }

  checkSPRExist(data: any) {
    return this.dataService.post('/api/checkSPRExist', data).map(response => {
      return response;
    })
  }

  saveSPReplacePaper(data: any) {
    return this.dataService.post('/api/saveSPReplacePaper', data).map(response => {
      return response;
    })
  }

  getBatchDamageList(data: any) {
    return this.dataService.post('/api/getBatchDamageList', data).map(response => {
      return response;
    })
  }

  getBatchDeleteList(data: any) {
    return this.dataService.post('/api/getBatchDeleteList', data).map(response => {
      return response;
    })
  }

  getTotalUserPapers(payload: any) {
    return this.dataService.post('/api/getTotalUserPapers', payload).map(response => {
      return response;
    });
  }

  getMinesPapers(payload: any) {
    return this.dataService.post('/api/getMinesPapers', payload).map(response => {
      return response;
    });
  }

  getReqPaperList(payload: any) {
    return this.dataService.post('/api/getReqPaperList', payload).map(response => {
      return response;
    });
  }

  requestSecurityPaper(payload: any) {
    return this.dataService.post('/api/saveSecurityPaper', payload).map(response => {
      return response;
    });
  }

  approveSecurityPaper(payload: any) {
    return this.dataService.post('/api/approveSecurityPaper', payload).map(response => {
      return response;
    });
  }


  allocateSecurityPaper(payload: any) {
    return this.dataService.post('/api/allocateSecurityPaper', payload).map(response => {
      return response;
    });
  }

  dispacthSecurityPaper(payload: any) {
    return this.dataService.post('/api/dispatchSecurityPaper', payload).map(response => {
      return response;
    });
  }

  receiveSecurityPaper(payload: any) {
    return this.dataService.post('/api/receiveSecurityPaper', payload).map(response => {
      return response;
    });
  }


  viewTransferData(payload: any) {
    return this.dataService.post('/api/viewTransferData', payload).map(response => {
      return response;
    });
  }

  // getStockYards(distObj: any) {
  //   // let data = {
  //   //   "id" : distId,
  //   // }
  //   return this.dataService.getData('/api/getStockYards', distObj);
  // }

  getStockYards(distObj: any) {
    return this.dataService.post('/api/getStockYards', distObj).map(response => {
      return response;
    });
  }

  viewApplByCode(url: any) {
    return this.dataService.post('/api/viewApplByCode/' + url, '').map(response => {
      return response;
    });
  }
  getapplicantDetail(user_id: any) {
    return this.dataService.getData('/api/getapplicant/' + user_id, true);
  }

  getdistrictData() {
    return this.dataService.getData('/api/get-tndistricts', true);
  }

  getregionlist(data) {
    return this.dataService.post('/api/region/list', data).map(response => {
      return response;
    });
  }

  getDistrictList(data) {
    return this.dataService.post('/api/district/list', data).map(response => {
      return response;
    });
  }


  districtSave(data) {
    return this.dataService.post('/api/district/save', data).map(response => {
      return response;
    });
  }

  saveEpermit(data) {
    return this.dataService.post('/api/apply/permit', data).map(response => {
      return response;
    });
  }

  saveTransitForm(payload) {
    return this.dataService.post('/api/saveTransitForm', payload).map(response => {
      return response;
    });
  }

  mineralSave(formData) {
    return this.dataService.post('/api/mine_quantity_manage', formData).map(response => {
      return response;
    });
  }

  getMineralUnit(mineral_id) {
    let payload = {
      'mineral_id': mineral_id,
    }
    return this.dataService.post('/api/getMineralsDets', payload).map(response => {
      return response;
    });
  }

  mineQuantityUpdate(formData) {
    return this.dataService.post('/api/mineQuantityUpdate', formData).map(response => {
      return response;
    });
  }

  geteChallan(data) {
    return this.dataService.post('/echallan/treasury/send', data).map(response => {
      return response;
    });
  }

  saveDispatch(data) {
    return this.dataService.post('/api/apply/dispatch', data).map(response => {
      return response;
    });
  }

  saveNewDispatch(data) {
    return this.dataService.post('/api/create/dispatch', data).map(response => {
      return response;
    });
  }

  editEpermit(data) {
    return this.dataService.post('/api/approve/permit', data).map(response => {
      return response;
    });
  }
  getDashboardList(data) {
    return this.dataService.post('/api/data/dashboard', data).map(response => {
      return response;
    });
  }
  updateChallan(data) {
    return this.dataService.post('/api/upload/challan', data).map(response => {
      return response;
    });
  }
  editDispatchSlip(data) {
    return this.dataService.post('/api/approve/dispatch', data).map(response => {
      return response;
    });
  }

  getChallanStatus(data) {
    return this.dataService.post('/echallan/status', data).map(response => {
      return response;
    });
  }

  getOtrChallanStatus(data) {
    return this.dataService.post('/echallan/otr/status', data).map(response => {
      return response;
    });
  }

  getSecurityPaperChallanStatus(data) {
    return this.dataService.post('/echallan/paper/status', data).map(response => {
      return response;
    });
  }

  COMPaymentStatus(data) {
    return this.dataService.post('/compayment/status', data).map(response => {
      return response;
    });
  }

  applicationStatus(data) {
    return this.dataService.post('/echallan/mines/status', data).map(response => {
      return response;
    });
  }

  reVerificationStatus(data) {
    return this.dataService.post('/paygov/epermit/status', data).map(response => {
      return response;
    });
  }

  reVerificationIFHRMSStatus(data) {
    return this.dataService.post('/echallan/epermit/status', data).map(response => {
      return response;
    });
  }

  payfeesReVerificationStatus(data) {
    return this.dataService.post('/paygov/register/status', data).map(response => {
      return response;
    });
  }

  paperPaygovReVerificationStatus(data) {
    return this.dataService.post('/paygov/paperverify/status', data).map(response => {
      return response;
    });
  }


  talukSave(data) {
    return this.dataService.post('/api/taluk/save', data).map(response => {
      return response;
    });
  }
  villageSave(data) {
    return this.dataService.post('/api/village/save', data).map(response => {
      return response;
    });
  }

  saveExisitingMines(form_data: any) {
    return this.dataService.post('/api/old_applications', form_data).map(response => {
      return response;
    });
  }

  saveExisitingMines2(form_data: any) {
    return this.dataService.post('/api/old_applications2', form_data).map(response => {
      return response;
    });
  }

  existMines(payload: any) {
    return this.dataService.post('/api/exist_mines', payload).map(response => {
      return response;
    });
  }

  updateExisitingMines(form_data: any) {
    return this.dataService.post('/api/old_applications_update2', form_data).map(response => {
      return response;
    });
  }

  // updateExisitingMines(form_data:any){
  //   return this.dataService.post('/api/old_applications_update', form_data).map(response =>{
  //     return response;
  //   });
  // }

  getExisitingMines(form_data: any) {
    return this.dataService.post('/api/old_applications_edit', form_data).map(response => {
      return response;
    });
  }

  getExisitingMinesDetails(form_data: any) {
    return this.dataService.post('/api/old_application_details', form_data).map(response => {
      return response;
    });
  }

  getExisitingMinesDetailsGrid(form_data: any) {
    return this.dataService.post('/api/old_application_details_grid', form_data).map(response => {
      return response;
    });
  }

  getMineDetailsData(form_data: any) {
    return this.dataService.post('/api/getMineDetailsData', form_data).map(response => {
      return response;
    });
  }

  getBulkPermitData(form_data: any) {
    return this.dataService.post('/api/getBulkPermitData', form_data).map(response => {
      return response;
    });
  }

  getDistricOfficers(form_data: any) {
    return this.dataService.post('/api/getDistricOfficers', form_data).map(response => {
      return response;
    });
  }

  enableMineEdit(data: any) {
    return this.dataService.post('/api/enableMineEdit', data).map(response => {
      return response;
    });
  }

  enableQtyofMineralsEdit(data: any) {
    return this.dataService.post('/api/enableQtyofMineralsEdit', data).map(response => {
      return response;
    });
  }

  delMinesQtyofMinerals(data: any) {
    return this.dataService.post('/api/delMinesQtyofMinerals', data).map(response => {
      return response;
    });
  }

  resetUserUid(data) {
    return this.dataService.post('/api/resetUserUid', data).map(response => {
      return response;
    });
  }

  setNewOfficerPassword(data) {
    return this.dataService.post('/api/setNewOfficerPassword', data).map(response => {
      return response;
    });
  }

  getYardDets(form_data: any) {
    return this.dataService.post('/api/getYardDets', form_data).map(response => {
      return response;
    });
  }
  getTalukLookup(form_data: any) {
    return this.dataService.post('/api/getYardDets', form_data).map(response => {
      return response;
    });
  }
  getVillageLookup(form_data: any) {
    return this.dataService.post('/api/getYardDets', form_data).map(response => {
      return response;
    });
  }

  getPermitDetails(permitId: any) {
    let data = {
      'permit_id': permitId
    }
    return this.dataService.post('/api/edit/permit', data).map(response => {
      return response;
    });
  }

  getTransactionHistory(data: any) {
    return this.dataService.post('/api/getTransactionHistory', data).map(response => {
      return response;
    })
  }

  getOtrTransactionHistory(data: any) {
    return this.dataService.post('/api/getOTRTransactionHistory', data).map(response => {
      return response;
    })
  }

  getPaperTransactionHistory(data: any) {
    return this.dataService.post('/api/getPaperTransactionHistory', data).map(response => {
      return response;
    });
  }

  getMinesTransactionHistory(data: any) {
    return this.dataService.post('/api/getMinesTransactionHistory', data).map(response => {
      return response;
    })
  }

  compayments(payload: any) {
    return this.dataService.post('/api/compayments', payload).map(response => {
      return response;
    });
  }

  getPaymentMethods() {
    return this.dataService.getData('/getCOMList', true);
  }

  getdispatchPermitDetails(permitId: any) {
    let data = {
      'permit_id': permitId
    }
    return this.dataService.post('/api/get/permit', data).map(response => {
      return response;
    });
  }

  getdispatchNotAvailable(permitId: any) {
    let data = {
      'epermit_id': permitId
    }
    return this.dataService.post('/api/dispatchNotAvailable', data).map(response => {
      return response;
    });
  }

  cancelDispatchRequest(data) {
    return this.dataService.post('/api/close/dispatch', data).map(response => {
      return response;
    });
  }

  cancelTransitRequest(data) {
    return this.dataService.post('/api/close/transit', data).map(response => {
      return response;
    });
  }

  getNextSPSeq(data: any) {

    return this.dataService.post('/api/getNextSPSeq', data).map(response => {
      return response;
    });
  }

  setSinglePaperasDamage(data: any) {

    return this.dataService.post('/api/setSinglePaperasDamage', data).map(response => {
      return response;
    });
  }

  getDispatchSlipDetails(dispatchId: any) {
    let data = {
      'dispatch_id': dispatchId
    }
    return this.dataService.post('/api/edit/dispatch', data).map(response => {
      return response;
    });
  }

  viewTransitForm(dispatchId: any) {
    let data = {
      'formID': dispatchId
    }
    return this.dataService.post('/api/viewTransitForm', data).map(response => {
      return response;
    });
  }

  updateAdNumber(data: any) {

    return this.dataService.post('/api/save/payment', data).map(response => {
      return response;
    });
  }

  getVehicleStatus(data: any) {

    return this.dataService.post('/api/check/vehicle', data).map(response => {
      return response;
    });
  }

  logVehicleCheck(vehicle_id: any) {
    let data = {
      'vehicle_id': vehicle_id
    }
    return this.dataService.post('/api/logVehicleCheck', data).map(response => {
      return response;
    });
  }


  IsVehicleRegistered(data: any) {
    let payload = {
      "vehicle_register_number": data
    }

    return this.dataService.post('/api/get_register_data', payload).map(response => {
      return response;
    });
  }

  changeVehicle(payload: any) {
    return this.dataService.post('/api/change/vehicle', payload).map(response => {
      return response;
    });
  }

  WeighBridgeSave(payload: any) {
    return this.dataService.post('/api/saveWeighbridge', payload).map(response => {
      return response;
    });
  }

  requestApplTransfer(payload: any) {
    return this.dataService.post('/api/requestApplTransfer', payload).map(response => {
      return response;
    });
  }

  approveApplTransfer(payload: any) {
    return this.dataService.post('/api/approveApplTransfer', payload).map(response => {
      return response;
    });
  }

  getVehicles() {
    return this.dataService.getData('/api/view/vehicles', true);
  }

  getApplBySlipCode(url: any) {
    return this.dataService.getData('/api/getApplBySlipCode/' + url, true);
  }

  getDispatchDetail(url: any) {
    return this.dataService.getData('/api/getDispatchslipDets/' + url, true);
  }

  scanPublicDispatch(url: any, locationData: any = null) {
    let dispatchIdNum = url;
    if (typeof url === 'string') {
      const digits = url.replace(/\D/g, '');
      if (digits) {
        dispatchIdNum = Number(digits);
      }
    }
    let payload: any = {
      dispatch_id: dispatchIdNum,
      ip_address: locationData?.ip_address || locationData?.ip || '',
      latitude: locationData?.latitude || null,
      longitude: locationData?.longitude || null,
      location_address: locationData?.location_address || locationData?.address || '',
      address: locationData?.address || locationData?.location_address || '',
      user_agent: navigator.userAgent
    };
    return this.dataService.post('/api/scan/dispatch', payload).map(response => {
      return response;
    });
  }

  getVehicleOwnerDetails(payload: any) {
    return this.dataService.post('/api/getVehicleOwnerDetails', payload).map(response => {
      return response;
    });
  }

  scanPublicTransit(url: any, locationData: any = null) {
    let passIdNum = url;
    if (typeof url === 'string') {
      const digits = url.replace(/\D/g, '');
      if (digits) {
        passIdNum = Number(digits);
      }
    }
    let payload: any = {
      pass_id: passIdNum,
      ip_address: locationData?.ip_address || locationData?.ip || '',
      latitude: locationData?.latitude || null,
      longitude: locationData?.longitude || null,
      location_address: locationData?.location_address || locationData?.address || '',
      address: locationData?.address || locationData?.location_address || '',
      user_agent: navigator.userAgent
    };
    return this.dataService.post('/api/scan/transit', payload).map(response => {
      return response;
    });
  }

  getApplicantByPan(url: any) {
    let data = {};
    return this.dataService.post('/api/getApplicantByPan/' + url, data).map(response => {
      return response;
    });
  }

  getMineralsList() {
    return this.dataService.getData('/api/getMineralsList', true);
  }
  paymentApproval(payload) {

    return this.dataService.post('/api/payapprove/permit', payload).map(response => {
      return response;
    });
  }

  vechileRegister(data: any) {
    return this.dataService.post('/api/save_vehicle', data).map(response => {
      return response;
    });
  }

  registerDevice(data: any) {
    return this.dataService.post('/api/device', data).map(response => {
      return response;
    });
  }

  getDevice(data: any) {
    return this.dataService.post('/api/get_single_device_data', data).map(response => {
      return response;
    });
  }
  getVehicle(data: any) {
    return this.dataService.post('/api/get_vehicle', data).map(response => {
      return response;
    });
  }

  postWebhooks(data: any) {
    // return this.dataService.triggerWebhook('/api/get_vehicle', data).map(response => {
    //     return response;
    // });

    return this.dataService.triggerWebhook('/api/list_vehicle/', true);
  }

  getDeviceList(data: any) {
    return this.dataService.getData('/api/get_device_data/', true);
  }

  getDeviceEdit(data: any) {
    return this.dataService.post('/api/view_device', data).map(response => {
      return response;
    });
  }

  getVehicleList(data: any) {
    return this.dataService.getData('/api/list_vehicle/', true);
  }

  getPlaybackVehicles() {
    return this.dataService.getData('/api/listvehicles', true);
  }

  updateVehicle(data: any) {
    return this.dataService.post('/api/update_vehicle', data).map(response => {
      return response;
    });
  }

  getVehicleTrackData(data: any) {
    return this.dataService.post('/api/trackVehicleDetails', data).map(response => {
      return response;
    });
  }

  getApplicantTrackAll() {
    return this.dataService.getRecord('/api/getApplicantTripTrackAll').map(response => {
      return response;
    })
  }

  getDistrictwiseGpsInstalledList(data: any) {
    return this.dataService.post('/api/districtwiseGpsInstalledList', data).map(response => {
      return response;
    })
  }

  gpsInstallationCount() {
    return this.dataService.getRecord('/api/gpsInstallationCount').map(response => {
      return response;
    })
  }

  updatePaymentStatus(permitId: any, status: any) {
    let data = {
      'permit_id': permitId,
      'pay_status': status
    }
    let url = `${environment.karuvoolamBaseUrl}/challan/deptchallan/`;
    return this.dataService.post('/api/payment/permit', data).map(response => {
      return response;
    });
  }

  redirectToEchalan(formData: any) {
    let url = `${environment.karuvoolamBaseUrl}/challan/deptchallan/`;
    return this.dataService.post(`${environment.karuvoolamBaseUrl}/challan/deptchallan/`, formData).map(response => {
      return response;
    });
  }


  liveSiteChecking(encValue: any) {

    let url = `${environment.karuvoolamBaseUrl}/challan/deptchallan/reverify?query=UwIVKM9SCz2Ra95TW0MosD3Sh1xwWMGrySQlJik%2FvTQAP0yLgFBM7yotGRfT9vX0cph3Lhp2%2BNIF5qvnExdrOuqJL0aoZrDQk6sBeV6qzWArlrNWjKeyZ%2BmvA3tcgFFI8FjeqqmR%2BVR5w9TSwzw7dA%3D%3D`;
    return this.dataService.directPost(url, true).map(response => {
      return response;
    });
  }

  getPermitMineral(permitId: any) {
    let data = {
      'permit_id': permitId
    }
    return this.dataService.post('/api/permit/minerals', data).map(response => {
      return response;
    });
  }

  getapplicantionDetail(applicationId: number, user_id: any) {
    return this.dataService.getData('/api/viewapplication/' + applicationId, true);
  }



  getEmptyWeight(id: any) {
    return this.dataService.getData('/api/getEmptyWeight/' + id, true);
  }

  getLoadedWeight(id: any) {
    return this.dataService.getData('/api/getLoadedWeight/' + id, true);
  }

  getMineralQuantity(data: any) {
    return this.dataService.post('/api/permit/quantity', data).map(response => {
      return response;
    });
  }
  getweighbridgeDets(application_id) {
    let data = {
      'application_id': application_id
    }
    return this.dataService.post('/api/getweighbridgeDets', data).map(response => {
      return response;
    });
  }

  getDirectMineralWeight(weighObj, weighbridgeurl) {
    return this.dataService.weightBridgepost(`${weighbridgeurl}/api/wb`, weighObj).map(response => {
      return response;
    });
  }

  decryptWeightValue(payload: any) {
    return this.dataService.post('/api/wb/wbgetweight', payload).map(response => {
      return response;
    });
  }

  returnWeight(urlID: any) {
    return this.dataService.getData('/api/returnWeight/' + urlID, true);
  }

  saveEmptyVehicleWeight(payload: any) {

    return this.dataService.post('/api/saveEmptyVehicleWeight', payload).map(response => {
      return response;
    });
  }

  saveLoadedVehicleWeight(payload: any) {

    return this.dataService.post('/api/saveLoadedVehicleWeight', payload).map(response => {
      return response;
    });
  }

  getEmptyVehicleWeight(payload: any) {
    return this.dataService.post('/api/getEmptyVehicleWeight', payload).map(response => {
      return response;
    });
  }


  setAsUnloaded(payload: any) {
    return this.dataService.post('/api/setAsUnloaded', payload).map(response => {
      return response;
    });
  }

  getLoadedVehicleWeight(payload: any) {
    return this.dataService.post('/api/getLoadedVehicleWeight', payload).map(response => {
      return response;
    });
  }

  getVehicleInOutDets(payload: any) {
    return this.dataService.post('/api/getVehicleInOutDets', payload).map(response => {
      return response;
    });
  }

  getPermitNumber() {
    return this.dataService.getData('/api/permit_numbers', true);
  }

  logVehiclesList() {
    return this.dataService.getData('/api/logVehiclesList', true);
  }
  getExistingMineCodes() {
    return this.dataService.getData('/api/view/minecodes', true);
  }

  getMineralsByMineCode(payload) {
    return this.dataService.post('/api/view/getminecodeminerals', payload).map(response => {
      return response;
    });
  }

  getMineralDetails() {
    return this.dataService.getData('/api/get_mine_quantity', true);;
  }
  getDetail(applicationName: number) {
    return this.dataService.getData('/api/getservicedescription/' + applicationName, true);
  }
  getFile(id) {
    return this.dataService.getData('/api/file/' + id, true);
  }

  getProfile(pageType) {
    if (pageType == 1) {
      return this.dataService.post('/api/user/profile', null).map(response => {
        return response;
      });
    } else {
      return this.dataService.post('/api/officer/profile', null).map(response => {
        return response;
      });
    }

  }

  getApplicantsMines() {
    return this.dataService.post('/api/getApplicantsMines', null).map(response => {
      return response;
    });
  }

  getApplicantsMinePermit(payload) {
    return this.dataService.post('/api/getApplicantsMinePermit', payload).map(response => {
      return response;
    });
  }


  editMineQuantity(application_id, mineral_id) {
    let payload = {
      "application_id": application_id,
      "mineral_id": mineral_id
    }
    return this.dataService.post('/api/editMineQuantity', payload).map(response => {
      return response;
    });

  }

  updateProfile(pageType, data) {
    if (pageType == 1) {
      return this.dataService.post('/api/user/profile/update', data).map(response => {
        return response;
      });
    } else {
      return this.dataService.post('/api/officer/profile/update', data).map(response => {
        return response;
      });
    }

  }


  permitVehiclesList(payload) {
    return this.dataService.post('/api/permitVehiclesList', payload).map(response => {
      return response;
    });
  }

  updateWithdraw(data) {
    return this.dataService.post('/api/setApplWithdraw', data).map(response => {
      return response;
    });
  }

  updateApproveWithdraw(data) {
    return this.dataService.post('/api/approveApplWithdraw', data).map(response => {
      return response;
    });
  }

  updateHold(data) {
    return this.dataService.post('/api/getApplicationHold', data).map(response => {
      return response;
    });
  }

  updateUnHold(data) {
    return this.dataService.post('/api/getApplicationunHold', data).map(response => {
      return response;
    });
  }

  updateReject(data) {
    return this.dataService.post('/api/getApplicationReject', data).map(response => {
      return response;
    });
  }

  getApplCodes() {
    return this.dataService.getData('/api/getApplCodes', true);
  }


  getDashboardData(data) {
    return this.dataService.post('/api/getDashboarddetails', data).map(response => {
      return response;
    });
  }

  Savegrievances(data) {
    return this.dataService.post('/api/add/grievances', data).map(response => {
      return response;
    });
  }

  saveStockYard(payload: any) {
    return this.dataService.post('/api/saveStockYard', payload).map(response => {
      return response;
    });
  }


  checkDeviceExist(payload: any) {
    return this.dataService.post('/api/checkDeviceExist', payload).map(response => {
      return response;
    });
  }

  saveDevice(payload: any) {
    return this.dataService.post('/api/save_device', payload).map(response => {
      return response;
    });
  }

  updateEditDevice(payload: any) {
    return this.dataService.post('/api/update_device', payload).map(response => {
      return response;
    });
  }

  updateStockYard(payload: any) {
    return this.dataService.post('/api/updateStockYard', payload).map(response => {
      return response;
    });
  }
  getgrievances(data: any) {
    return this.dataService.post('/api/viewall/grievances/', data);
  }
  getusergrievances(data: any) {
    return this.dataService.post('/api/view/grievances/', data);
  }
  getGrievancesById(data: any) {
    return this.dataService.post('/api/edit/grievances/', data);
  }
  SavegrievancesByCGM(data) {
    return this.dataService.post('/api/update/grievances', data).map(response => {
      return response;
    });
  }
  gethrbydistance(data) {
    return this.dataService.post('/api/get/minutes', data);
  }
  getMines(data: any) {
    return this.dataService.post('/api/get/mines/', data);
  }
  getPermitAmount(data: any) {
    return this.dataService.post('/api/get/permitamount/', data);
  }
  getUserDashboardData(data: any) {
    return this.dataService.post('/api/userdata/dashboard', data);
  }




  checkRegVehicle(data: any) {
    let payload = {
      "vehicleNo": data
    };
    return this.dataService.post('/api/checkRegVehicle', payload);
  }

  getVahanVehicleDetails(vehicleNumber: any) {
    let payload = {
      "regNo": vehicleNumber,
      "vehicle_no": vehicleNumber
    };
    return this.dataService.post('/api/vahan/getVehicleDetails', payload);
  }

  saveDriverDetails(payload: any) {
    return this.dataService.post('/api/save_driver', payload).map(response => {
      return response;
    });
  }

  getDriverList() {
    return this.dataService.getRecord('/api/list_driver').map(response => {
      return response;
    });
  }

  getDriverDetails(payload: any) {
    return this.dataService.post('/api/get_driver', payload).map(response => {
      return response;
    });
  }

  updateDriverDetails(payload: any) {
    return this.dataService.post('/api/update_driver', payload).map(response => {
      return response;
    });
  }

  deleteDriverDetails(payload: any) {
    return this.dataService.post('/api/delete_driver', payload).map(response => {
      return response;
    });
  }

  permitDriversList(payload: any) {
    return this.dataService.post('/api/permitDriversList', payload).map(response => {
      return response;
    })
  }

  checkDriver(payload: any) {
    return this.dataService.post('/api/check/driver', payload).map(response => {
      return response;
    })
  }

  checkOtherPassDispatch(payload: any) {
    return this.dataService.post('/api/check/otherpassdispatch', payload).map(response => {
      return response;
    })
  }

  checkRegDriver(payload: any) {
    return this.dataService.post('/api/checkRegDriver', payload).map(response => {
      return response;
    })
  }

  getSYList() {
    return this.dataService.getRecord('/api/getSYList').map(response => {
      return response;
    })
  }

  getSYSlipList(payload: any) {
    return this.dataService.post('/api/getSYSlipList', payload).map(response => {
      return response;
    })
  }

  applyTransitPermit(payload: any) {
    return this.dataService.post('/api/apply/transitpermit', payload).map(response => {
      return response;
    })
  }

  getTransitPermitList(payload: any) {
    return this.dataService.post('/api/list/transitpermit', payload).map(response => {
      return response;
    })
  }

  editTransitPermit(payload: any) {
    return this.dataService.post('/api/edit/transitpermit', payload).map(response => {
      return response;
    })
  }

  viewTransitPermit(payload: any) {
    return this.dataService.post('/api/view/otherpass', payload).map(response => {
      return response;
    })
  }

  approveTransitPermit(payload: any) {
    return this.dataService.post('/api/approve/transitpermit', payload).map(response => {
      return response;
    })
  }

  getTransitPermits() {
    return this.dataService.getRecord('/api/transitpermit_numbers').map(response => {
      return response;
    })
  }

  getTransitPermitdetails(payload: any) {
    return this.dataService.post('/api/get/transit_permit', payload).map(response => {
      return response;
    })
  }

  getTransitVehicleList(payload: any) {
    return this.dataService.post('/api/transpermitVehiclesList', payload).map(response => {
      return response;
    })
  }

  applyTransitPass(payload: any) {
    return this.dataService.post('/api/apply/transitpass', payload).map(response => {
      return response;
    })
  }

  applyOtherTransitPass(payload: any) {
    return this.dataService.post('/api/apply/othertransitpass', payload).map(response => {
      return response;
    })
  }

  getOtherTransitPassList(payload: any) {
    return this.dataService.post('/api/list/othertransit', payload).map(response => {
      return response;
    })
  }
  
  applyOtherPass(payload: any) {
    return this.dataService.post('/api/save/otherpass', payload).map(response => {
      return response;
    })
  }

  getOtherPassList(payload: any) {
    return this.dataService.post('/api/list/others', payload).map(response => {
      return response;
    })
  }

  forwardPass(payload: any) {
    return this.dataService.post('/api/forward/otherpass', payload).map(response => {
      return response;
    })
  }

  approvePass(payload: any) {
    return this.dataService.post('/api/approve/otherpass', payload).map(response => {
      return response;
    })
  }

  editOtherTransitPassList(payload: any) {
    return this.dataService.post('/api/edit/othertransitpass', payload).map(response => {
      return response;
    })
  }

  transitNotAvailable(payload: any) {
    return this.dataService.post("/api/transitNotAvailable", payload).map(response => {
      return response;
    });
  }

  getTransitPassLists(data: any) {
    return this.dataService.post('/api/list/transit', data).map(response => {
      return response;
    })
  }

  getCreateTransitPassLists() {
    return this.dataService.getRecord('/api/list/transitpass').map(response => {
      return response;
    })
  }

  getTransitPassDetails(payload: any) {
    return this.dataService.post('/api/edit/transitpass', payload).map(response => {
      return response;
    })
  }

  getTPassReportInputs() {
    return this.dataService.getRecord('/api/getTPassReportInputs').map(response => {
      return response;
    })
  }

  getTPassReportList(payload: any) {
    return this.dataService.post('/api/getTPassReportList', payload).map(response => {
      return response;
    })
  }

  getPassReportList(payload: any) {
    return this.dataService.post('/api/getPassReportList', payload).map(response => {
      return response;
    })
  }

  getStockYardCodes() {
    return this.dataService.getRecord('/api/view/stockcodes').map(response => {
      return response;
    });
  }

  stockqtysave(payload: any) {
    return this.dataService.post('/api/stockqtysave', payload).map(response => {
      return response;
    })
  }

  get_stock_quantity() {
    return this.dataService.getRecord('/api/get_stock_quantity').map(response => {
      return response;
    });
  }

  editstockqty(payload: any) {
    return this.dataService.post('/api/editstockqty', payload).map(response => {
      return response;
    })
  }

  stockqtyupdate(payload: any) {
    return this.dataService.post('/api/stockqtyupdate', payload).map(response => {
      return response;
    })
  }

  getstockmineralqty(payload: any) {
    return this.dataService.post('/api/getstockmineralqty', payload).map(response => {
      return response;
    })
  }

  //dashboardCgm

  getEappSummary(payload: any) {
    return this.dataService.post('/api/getEappSummary', payload).map(response => {
      return response;
    })
  }

  getEappBarSummary(payload: any) {
    return this.dataService.post('/api/getEappBarSummary', payload).map(response => {
      return response;
    })
  }

  getEappListSummary(payload: any) {
    return this.dataService.post('/api/getEappListSummary', payload).map(response => {
      return response;
    })
  }

  getEappDetails(payload: any) {
    return this.dataService.post('/api/getEappDetails', payload).map(response => {
      return response;
    })
  }

  getEappDistrictSummary(payload: any) {
    return this.dataService.post('/api/getEappDistrictSummary', payload).map(response => {
      return response;
    })
  }

  getEappMonthPendSummary(payload: any) {
    return this.dataService.post('/api/getEappMonthPendSummary', payload).map(response => {
      return response;
    })
  }

  //Mineral dashboard

  getMineralTotalSummary(payload: any) {
    return this.dataService.post('/api/getMineralTotalSummary', payload).map(response => {
      return response;
    })
  }

  getMineralWiseSummary(payload: any) {
    return this.dataService.post('/api/getMineralWiseSummary', payload).map(response => {
      return response;
    })
  }

  getMineralDistrictWiseSummary(payload: any) {
    return this.dataService.post('/api/getMineralDistrictWiseSummary', payload).map(response => {
      return response;
    })
  }

  getMineralProdMonthWiseSummary(payload: any) {
    return this.dataService.post('/api/getMineralProdMonthWiseSummary', payload).map(response => {
      return response;
    })
  }

  getMineralApplicantWiseSummary(payload: any) {
    return this.dataService.post('/api/getMineralApplicantWiseSummary', payload).map(response => {
      return response;
    })
  }

  //mineralDashboardEnd

  getYardDetailsData(payload: any) {
    return this.dataService.post('/api/getYardDetailsData', payload).map(response => {
      return response;
    })
  }

  enableYardEdit(payload: any) {
    return this.dataService.post('/api/enableYardEdit', payload).map(response => {
      return response;
    })
  }

  //security-paper Dashboard start

  getSPIODistrictSummary(payload: any) {
    return this.dataService.post('/api/getSPIODistrictSummary', payload).map(response => {
      return response;
    })
  }

  getSPIODistrictList(payload: any) {
    return this.dataService.post('/api/getSPIODistrictList', payload).map(response => {
      return response;
    })
  }

  getSPIOMineDets(payload: any) {
    return this.dataService.post('/api/getSPIOMineDets', payload).map(response => {
      return response;
    })
  }

  //security-paper Dashboard end

  //District batch Assign Start 

  saveDistrictSecurityPaper(data) {
    return this.dataService.post('/api/saveDistrictSecurityPaper', data).map(response => {
      return response;
    });
  }

  getDistrictSecurityBatchList(data) {
    return this.dataService.post('/api/getDistrictSecurityBatchList', data).map(response => {
      return response;
    });
  }

  //District batch Assign End

  getMinesPermits(data) {
    return this.dataService.post('/api/getMinesPermits', data).map(response => {
      return response;
    });
  }

  getSPRequestStatus(data) {
    return this.dataService.post('/api/getSPRequestStatus', data).map(response => {
      return response;
    });
  }

  getSPAllocateStatus(data) {
    return this.dataService.post('/api/getSPAllocateStatus', data).map(response => {
      return response;
    });
  }

  //District Batch assign end

  getRegisteredRule192a() {
    return this.dataService.getRecord('/api/list/mines192a_list').map(response => {
      return response;
    });
  }

  getSavedFormDets(data) {
    return this.dataService.post('/api/getSavedFormDets', data).map(response => {
      return response;
    });
  }

  requestMinePeriodExtend(data) {
    return this.dataService.post('/api/requestMinePeriodExtend', data).map(response => {
      return response;
    });
  }

  // Trip Wise Tracking Api's Start

  // `silent` (when true) marks the underlying HTTP request so the interceptor skips the
  // global loader for it — used for background interval polling (see interceptor.service.ts).
  private silentHeaders(silent?: boolean): HttpHeaders {
    return silent ? new HttpHeaders({ 'x-silent-loader': 'true' }) : undefined;
  }

  getTripTrackList(data, typeId: number, silent?: boolean) {
    if (typeId == 1) {
      return this.getDSTripTrackList(data, silent);
    }
    else if (typeId == 2) {
      return this.getTPTripTrackList(data, silent);
    }
  }

  getTripTrackSummary(data, typeId: number, silent?: boolean) {
    if (typeId == 1) {
      return this.getDSTripTrackSummary(data, silent);
    }
    else if (typeId == 2) {
      return this.getTPTripTrackSummary(data, silent);
    }
  }

  getDSTripTrackSummary(data, silent?: boolean) {
    return this.dataService.post('/api/getDSTripTrackSummary', data, this.silentHeaders(silent)).map(response => {
      return response;
    });
  }

  getDSTripTrackList(data, silent?: boolean) {
    return this.dataService.post('/api/getDSTripTrackList', data, this.silentHeaders(silent)).map(response => {
      return response;
    });
  }

  getTPTripTrackSummary(data, silent?: boolean) {
    return this.dataService.post('/api/getTPTripTrackSummary', data, this.silentHeaders(silent)).map(response => {
      return response;
    });
  }

  getTPTripTrackList(data, silent?: boolean) {
    return this.dataService.post('/api/getTPTripTrackList', data, this.silentHeaders(silent)).map(response => {
      return response;
    });
  }

  getTripTrackDets(data, typeId: number) {
    if (typeId == 1) {
      return this.getDSTripTrackDets(data);
    }
    else if (typeId == 2) {
      return this.getTPTripTrackDets(data);
    }
  }

  getDSTripTrackDets(data) {
    return this.dataService.post('/api/getDSTripTrackDets', data).map(response => {
      return response;
    });
  }

  getTPTripTrackDets(data) {
    return this.dataService.post('/api/getTPTripTrackDets', data).map(response => {
      return response;
    });
  }

  getDSTripPlayBackList(data) {
    return this.dataService.post('/api/getDSTripPlayBackList', data).map(response => {
      return response;
    });
  }

  getTripTrackAll(data, typeId: number, silent?: boolean) {
    if (typeId == 1) {
      return this.getDSTripTrackAll(data, silent);
    }
    else if (typeId == 2) {
      return this.getTPTripTrackAll(data, silent);
    }
  }

  getDSTripTrackAll(data, silent?: boolean) {
    return this.dataService.post('/api/getDSTripTrackAll', data, this.silentHeaders(silent)).map(response => {
      return response;
    });
  }

  getTPTripTrackAll(data, silent?: boolean) {
    return this.dataService.post('/api/getTPTripTrackAll', data, this.silentHeaders(silent)).map(response => {
      return response;
    });
  }

  // Trip Wise Tracking Api's End

  //vehicle devive approve api's

  getInstallVehiclesList(data, silent?: boolean) {
    return this.dataService.post('/api/getInstallVehiclesList', data, this.silentHeaders(silent)).map(response => {
      return response;
    });
  }

  getInstallVehiclesDets(data) {
    return this.dataService.post('/api/getInstallVehiclesDets', data).map(response => {
      return response;
    });
  }

  getApplStatusList(data: any) {
    return this.dataService.post('/api/getApplStatusList', data).map(response => {
      return response;
    });
  }

  getApplStatusSummary(data: any) {
    return this.dataService.post('/api/getApplStatusSummary', data).map(response => {
      return response;
    });
  }

  deviceDetsUpdate(data) {
    return this.dataService.post('/api/deviceDetsUpdate', data).map(response => {
      return response;
    });
  }

  approveDeviceDets(data) {
    return this.dataService.post('/api/approveDeviceDets', data).map(response => {
      return response;
    });
  }

  getDeviceManufacturers() {
    return this.dataService.getRecord('/api/devicesMades').map(response => {
      return response;
    })
  }

  importBulkDevices(data) {
    return this.dataService.post('/api/importBulkDevices', data).map(response => {
      return response;
    });
  }

  getManufactureList(data) {
    return this.dataService.post('/api/getManufactureList', data).map(response => {
      return response;
    });
  }
  getDevicesList(data) {
    return this.dataService.post('/api/devicesList', data).map(response => {
      return response;
    })
  }

  getManufactureDets(data) {
    return this.dataService.post('/api/getManufactureDets', data).map(response => {
      return response;
    });
  }

  saveManufacturer(data) {
    return this.dataService.post('/api/saveManufacturer', data).map(response => {
      return response;
    });
  }

  updateManufacturer(data) {
    return this.dataService.post('/api/updateManufacturer', data).map(response => {
      return response;
    });
  }

  getDeviceDets(data) {
    return this.dataService.post('/api/devicesDets', data).map(response => {
      return response;
    });
  }

  updateDevice(data) {
    return this.dataService.post('/api/devicesUpdate', data).map(response => {
      return response;
    });
  }

  removeDevice(data) {
    return this.dataService.post('/api/removeDevices', data).map(response => {
      return response;
    })
  }

  getManufacturerSubuserList(data) {
    return this.dataService.post('/api/getSubuserList', data).map(response => {
      return response;
    });
  }

  saveoemsubuser(data) {
    return this.dataService.post('/api/saveoemsubuser', data).map(response => {
      return response;
    });
  }

  updateoemsubuser(data) {
    return this.dataService.post('/api/updateoemsubuser', data).map(response => {
      return response;
    });
  }

  getOemSubUserDets(data) {
    return this.dataService.post('/api/getoemsubuserdets', data).map(response => {
      return response;
    });
  }

  checkMobileExist(data) {
    return this.dataService.post('/api/checkMobileExist', data).map(response => {
      return response;
    });
  }

  setOEMSubuserStatus(data) {
    return this.dataService.post('/api/setOEMSubuserStatus', data).map(response => {
      return response;
    });
  }
  
  getMineDetails(data) {
    return this.dataService.post('/api/viewMineDetails', data);
  }

  getOtrDetails() {
    return this.dataService.getData('/api/getOtrDets', true);
  }

  getOtrFormDetails(data) {
    return this.dataService.post('/api/otrFormDets', data);
  }

  getOtrViewDetails(data) {
    return this.dataService.post('/api/otrFormView', data);
  }

  getOTRDetailsGrid(form_data: any) {
    return this.dataService.post('/api/otrFormList', form_data).map(response => {
      return response;
    });
  }

  getRDOList(data: any) {
    return this.dataService.post('/api/otrRDOList', data).map(response => {
      return response;
    });
  }

  updateOTRForm(data) {
    return this.dataService.post('/api/otrAdApproval', data).map(response => {
      return response;
    });
  }

  saveOTRForm(data) {
    return this.dataService.post('/api/otrFormSave', data).map(response => {
      return response;
    });
  }

  saveDCApproval(data) {
    return this.dataService.post('/api/otrDCApproval', data).map(response => {
      return response;
    });
  }

  returnApplication(data) {
    return this.dataService.post('/api/otrDCReturn', data).map(response => {
      return response;
    });
  }

  //vehicle device approve api's end


  //vehicle report api's

  districtMineVechiles(data) {
    return this.dataService.post('/api/districtMineVechiles', data).map(response => {
      return response;
    });
  }

  districtMineVechilesDets(data) {
    return this.dataService.post('/api/districtMineVechilesDets', data).map(response => {
      return response;
    });
  }

  districtwiseVechilesMapping() {
    return this.dataService.getRecord('/api/districtwiseVechilesMapping').map(response => {
      return response;
    });
  }

  districtwiseCurrentVechilesMapping() {
    return this.dataService.getRecord('/api/districtwiseCurrentVechilesMapping').map(response => {
      return response;
    });
  }

  districtwiseRegCurrentVechilesMapping() {
    return this.dataService.getRecord('/api/districtwiseRegCurrentVechilesMapping').map(response => {
      return response;
    });
  }

  districtwiseVechilesDets(data) {
    return this.dataService.post('/api/districtwiseVechilesDets', data).map(response => {
      return response;
    });
  }

  districtwiseRegVechilesMapping() {
    return this.dataService.getRecord('/api/districtwiseRegVechilesMapping').map(response => {
      return response;
    });
  }

  districtwiseRegVechilesDets(data) {
    return this.dataService.post('/api/districtwiseRegVechilesDets', data).map(response => {
      return response;
    });
  }

  searchVehicle(data) {
    return this.dataService.post('/api/showVechilesDets', data).map(response => {
      return response;
    });
  }

  vehicleDetails(data) {
    return this.dataService.post('/api/vehicle_type_details', data).map(response => {
      return response;
    });
  }

  //vehicle report api's end

  //Brick Earth Permits api's

  applyBrickPermit(data) {
    return this.dataService.post('/api/apply/brickpermit', data).map(response => {
      return response;
    });
  }

  brickPermitList() {
    return this.dataService.post('/api/brickPermitList', {}).map(response => {
      return response;
    });
  }

  updateMineLocation(data) {
    return this.dataService.post('/api/updateMineLocation', data).map(response => {
      return response;
    });
  }

  viewBrickPermit(data) {
    return this.dataService.post('/api/viewBrickPermit', data).map(response => {
      return response;
    });
  }

  brickMinecodeList() {
    return this.dataService.getData('/api/bricks/minecodes', true);
  }

  getBrickPermitReportList(data: any) {
    return this.dataService.post('/api/getBrickPermitReportList', data);
  }

  //Brick Earth Permits api's end

  getMineralDetailsList() {
    return this.dataService.getData('/api/list/minerals', true);
  }

  getMapDets() {
    return this.dataService.getRecord('/api/getMapDets');
  }

  // Google maps api's

  getDistanceFromLocationDispatch(data) {
    return this.dataService.post('/api/distance/dispatch', data)
  }

  getDistanceFromLocationTransit(data) {
    return this.dataService.post('/api/distance/transit', data)
  }

  getPlacesAutocomplete(data): Observable<PlacesResult[]> {
    if (this.autoCompleteCache.has(data.input)) {
      return of(this.autoCompleteCache.get(data.input)!);
    }
    return this.dataService.post('/api/autosearch/address', data).pipe(
      tap(results => this.autoCompleteCache.set(data.input, results)),
      catchError(() => of([]))
    );
  }

  clearCache() {
    this.autoCompleteCache.clear();
  }

  getBulkPermitMonitoring(data: any = {}) {
    return this.dataService.getRecord('/api/bulkPermitMonitoring');
  }

  getWbUserCount() {
    return this.dataService.getRecord('/api/getwbuserCount').map(response => response);
  }

  getWbApplicants() {
    return this.dataService.getRecord('/api/getwbapplicants/').map(response => response);
  }

  getSubUsers() {
    return this.dataService.getRecord('/api/getsubusers').map(response => response);
  }

  updateWbApplicant(payload: any) {
    return this.dataService.post('/api/updatewbapplicant', payload).map(response => response);
  }

  updateWbSubuser(payload: any) {
    return this.dataService.post('/api/updatewbsubuser', payload).map(response => response);
  }

  updateWbSubuserStatus(payload: any) {
    return this.dataService.post('/api/updatewbsubuser', payload).map(response => response);
  }

  updateWbApplicantStatus(payload: any) {
    return this.dataService.post('/api/updatewbapplicant', payload).map(response => response);
  }

  getDistrictwiseRegVehicleGpsStatus(payload: any = {}) {
    return this.dataService.post('/api/districtwiseRegVehicleGpsStatus', payload).map(response => response);
  }

  getDistrictwiseRegVehicleGpsSummaryCount(payload: any = {}) {
    return this.dataService.post('/api/districtwiseRegVehicleGpsSummaryCount', payload).map(response => response);
  }

  getDistrictwiseRegVehicleGpsDets(payload: any = {}) {
    return this.dataService.post('/api/districtwiseRegVehicleGpsDets', payload).map(response => response);
  }
}
